import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isAboutDropdownOpen, setIsAboutDropdownOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'nav-link active' : 'nav-link';
  };

  const toggleAboutDropdown = () => {
    setIsAboutDropdownOpen(!isAboutDropdownOpen);
  };

  const closeAboutDropdown = () => {
    setIsAboutDropdownOpen(false);
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <Link to="/" className="logo">
          <img 
            src="/img/logo_vr_group_22.png" 
            alt="VREco Energy Pvt Ltd" 
            style={{ 
              height: '130px',
              width: '130px',
              objectFit: 'contain',
              objectPosition: 'center',
              imageRendering: 'auto',
              display: 'block',
              padding: '3px 0'
            }}
            loading="eager"
            decoding="async"
            fetchPriority="high"
          />
        </Link>
        <div className={`menu-toggle ${isMobileMenuOpen ? 'active' : ''}`} onClick={toggleMobileMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <ul className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
          <li><Link to="/" className={isActive('/')} onClick={closeMobileMenu}>Home</Link></li>
          <li className="dropdown" onMouseEnter={() => setIsAboutDropdownOpen(true)} onMouseLeave={() => setIsAboutDropdownOpen(false)}>
            <span className={`nav-link dropdown-toggle ${location.pathname === '/about' || location.pathname === '/vr-group' ? 'active' : ''}`} onClick={toggleAboutDropdown}>
              About Us
            </span>
            <ul className={`dropdown-menu ${isAboutDropdownOpen ? 'show' : ''}`}>
              <li><Link to="/about" className="dropdown-link" onClick={() => {closeMobileMenu(); closeAboutDropdown();}}>About Us</Link></li>
              <li><Link to="/about#mission-vision" className="dropdown-link" onClick={() => {
                closeMobileMenu(); 
                closeAboutDropdown();
                // Small delay to allow navigation, then scroll to section
                setTimeout(() => {
                  const element = document.querySelector('#mission-vision');
                  if (element) {
                    const offsetTop = element.offsetTop - 100;
                    window.scrollTo({
                      top: offsetTop,
                      behavior: 'smooth'
                    });
                  }
                }, 500);
              }}>Our Vision</Link></li>
              <li><Link to="/vr-group" className="dropdown-link" onClick={() => {closeMobileMenu(); closeAboutDropdown();}}>VR Group</Link></li>
            </ul>
          </li>
          <li><Link to="/services" className={isActive('/services')} onClick={closeMobileMenu}>Services</Link></li>
          <li><Link to="/projects" className={isActive('/projects')} onClick={closeMobileMenu}>Projects</Link></li>
          <li><Link to="/utility" className={isActive('/utility')} onClick={closeMobileMenu}>Utility</Link></li>
          <li><Link to="/career" className={isActive('/career')} onClick={closeMobileMenu}>Career</Link></li>
          <li><Link to="/contact" className={isActive('/contact')} onClick={closeMobileMenu}>Contact</Link></li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;